import { StylesConfig } from 'react-select'

import Autocomplete from 'common/components/autcomplete'
import { SelectValue } from 'common/components/BaseSelect'

const customStyles: StylesConfig<SelectValue, false> = {
  option: (_, state) => {
    return {
      padding: '10px 20px',
      minHeight: 56,
      height: 'auto',
      display: 'flex',
      alignItems: 'center',
      backgroundColor: !state.isFocused ? '' : '#f3f4f6',
    }
  },
}

type Props = {
  onSearch: (value: string) => void
  options: SelectValue[] | undefined
  placeholder?: string
  'aria-label'?: string
}

const IntegrationsSearchbox = ({
  onSearch,
  options,
  placeholder = 'Find content',
  'aria-label': ariaLabel,
}: Props) => {
  return (
    <Autocomplete
      className="w-60 ml-4"
      aria-label={ariaLabel}
      placeholder={placeholder}
      options={options}
      onSearch={onSearch}
      backspaceRemovesValue={true}
      customStyles={customStyles}
    />
  )
}

export default IntegrationsSearchbox
